import { Typography, styled } from "@mui/material"
import { extraColors } from "../../utils/theme"

export const Tag = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2Bold,
  textTransform: "uppercase",
  color: extraColors.status.navyLight,
}))
